import React, { useState, useEffect } from "react";
import SideBar from "../Sidebar";
import Header from "../Header";

const Layout = ({ children }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);

    const toggleNav = (e) => {
        e.preventDefault();
        setIsSidebarOpen(prevState => !prevState);
    };

    useEffect(() => {
        const container = document.getElementById("container");
        if (isSidebarOpen) {
            container.classList.add("sidebar-open");
        } else {
            container.classList.remove("sidebar-open");
        }
    }, [isSidebarOpen]);

    return (
        // <div id="container" className="container-fluid position-relative d-flex p-0 overflow-hidden">
        //     <div id="mySidebar" className="sidebar">
        //         <SideBar toggleNav={toggleNav}/>
        //     </div>

        //     <div id="main" className="content">
        //         <Header toggleNav={toggleNav} />
        //         <div className="children-container">
        //         {children}
        //         </div>
        //     </div>
        // </div>
        <div id="container" className="container-fluid position-relative d-flex p-0 overflow-hidden">
            <div id="mySidebar" className="sidebar">
                <SideBar />
            </div>

            <div id="main" className="content">
                <Header />
                <div className="children-container">
                    {children}
                </div>
            </div>
        </div>
    )
}

export default Layout;